import React from 'react';

import { FormControl, InputLabel, MenuItem, Select, TableRow } from '@material-ui/core';

import { NoBorderCell } from 'components/common/table/TableStyle';
import { BoldText } from '../ModalContent.styled';
import { CouponReason, couponReasonOption } from 'constants/member/connect';
import { SelectChangeEvent } from 'types/common/select';
import { CouponFormField } from 'types/member';

interface Props {
  couponReason: CouponReason;
  onChangeValue: (event: SelectChangeEvent) => void;
}

const Context = ({ couponReason, onChangeValue }: Props) => {
  return (
    <TableRow>
      <NoBorderCell>
        <BoldText>Context</BoldText>
      </NoBorderCell>
      <NoBorderCell align={'left'}>
        <FormControl size="small" style={{ minWidth: 150, textAlign: 'center' }}>
          <Select
            name={CouponFormField.REASON}
            value={couponReason}
            onChange={onChangeValue}
            label="Context"
          >
            {couponReasonOption.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </NoBorderCell>
    </TableRow>
  );
};

export default Context;
